import { http } from '@/core/api/';

const hrBaseURL = 'api/hralternativelocations';

export const getLocationSchools = async (params) => {
  return await http.get(`${hrBaseURL}/locationschools`, {
    params,
  });
};

export const getSchoolAlternativeLocations = async (params) => {
  return await http.get(`${hrBaseURL}/schoolalternativelocations`, {
    params,
  });
};

export const getAlternativeLocationTeacherStudents = async (params) => {
  return await http.get(`${hrBaseURL}/alternativelocationteacherstudents`, {
    params,
  });
};

export const getAvailableSchoolStudents = async (params) => {
  return await http.get(`${hrBaseURL}/availableschoolstudents`, {
    params,
  });
};

export const getAvailableAssistants = async (params) => {
  return await http.get(`${hrBaseURL}/availableassistants`, {
    params,
  });
};

export const getAlternativeLocationTeacherAssistants = async (params) => {
  return await http.get(`${hrBaseURL}/alternativelocationteacherassistants`, {
    params,
  });
};

export const getAlternativeLocationTeacher = async (params) => {
  return await http.get(`${hrBaseURL}/alternativelocationteacher`, {
    params,
  });
};

export const getSpecialEducationEmployees = async (params) => {
  return await http.get(`${hrBaseURL}/specialeducationemployees`, {
    params,
  });
};

export const saveAlternativeLocationTeacher = async (data) => {
  return await http.post(`${hrBaseURL}/savealternativelocationteacher`, data);
};

export const assignAssistantsToSAEE10 = async (data) => {
  return await http.post(`${hrBaseURL}/assignassistantstosaee10`, data);
};

export const addAssistantToTeacher = async (data) => {
  return await http.post(`${hrBaseURL}/addassistant`, data);
};

export const removeAssistantFromTeacher = async (data) => {
  return await http.post(`${hrBaseURL}/removeassistant`, data);
};

export const assignStudentToTeacher = async (data) => {
  return await http.post(`${hrBaseURL}/assignstudent`, data);
};

export const unassignStudentToTeacher = async (data) => {
  return await http.post(`${hrBaseURL}/unassignstudent`, data);
};

export const syncAssignedStudent = async (data) => {
  return await http.post(`${hrBaseURL}/syncassignedstudent`, data);
};

export const getSchoolTeacher = async (params) => {
  return await http.get(`${hrBaseURL}/schoolteacher`, {
    params,
  });
};

export const resetAlternativeLocation = async (data) => {
  return await http.post(`${hrBaseURL}/resetalternativelocation`, data);
};

export const addTeacher = async (payload) =>
  http.post(`${hrBaseURL}/addteacher`, payload);

export const generateRandomSSN = async () =>
  http.get(`${hrBaseURL}/generaterandomssn`);
